"use client";

import { ReactNode, useEffect } from "react";
import { useRouter } from "next/navigation";
import { getCookie } from "@/lib/cookies";
import MobileMenu from "@/components/layout/mobilemenu/MobileMenu";

interface Props {
  children: ReactNode;
}

export default function AuthLayout({ children }: Props) {
  const router = useRouter();

  useEffect(() => {
    if (getCookie("access_token") && getCookie("refresh_token")) {
      const params = new URLSearchParams(window.location.search);
      const returnTo = params.get("returnTo");
      const target = returnTo && returnTo.startsWith("/") ? returnTo : "/";
      router.replace(target);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <>{children} <MobileMenu /></>;
}
